import { DakokuApi } from '@/api/DakokuApi'
import {
  DakokuDataFull, DakokuReq, GetKinmuListReq, GetDakokuReq, DakokuData,
  KinmuListData, KyuukeiReq, KintaiSummaryData, GetKintaiSummaryReq, DakokuSyouninReq,
  GetKinmuListRes, HakenKinmuListData, HakenDakokuData, HonninNotesReq,
  CloseKintaiSummaryReq, CloseCancelKintaiSummaryReq, HakenModifyDatas, boolRes, GetKinmuListBySummaryIdReq, RecalcDakokByDakokuInfo, RecalcDakokByDakokuInfouReq
} from '@/types/Dakoku'
import { DateUtil } from '@/utils/DateUtil';

import { DialogService } from "@/service/DialogService";
import Message from '@/const/Message';
import { cloneDeep, isNull, isString } from 'lodash';
import { SoumuSyuuseiReq } from '@/types/SoumuSyuusei';
export class DakokuService {


  public async getDakokuData(syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null): Promise<DakokuData> {
    const api = new DakokuApi()
    const req: GetDakokuReq = {
      syuugyouBasyoId,
      koyouKeiyakuId,
      koyouKeiyakuTimeId
    }

    let res = null;
    try {
      res = await api.getDakokuData(req)
      if (!res) {
        throw new Error('');
      }
    } catch (e: any) {
      DialogService.error({
        title: Message.ERROR_GET_DAKOKU.DIALOG_TITLE,
        text: Message.ERROR_GET_DAKOKU.TEXT
      })
    }

    return await this.createDakokuData(res)
  }

  public async syukkin(syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null): Promise<Boolean> {
    const api = new DakokuApi()
    const req: DakokuReq = {
      syuugyouBasyoId,
      koyouKeiyakuId,
      koyouKeiyakuTimeId
    }

    let res = null;
    try {
      res = await api.syukkin(req)
    } catch (e: any) {
      console.error(e);
      return false
    }

    return true
  }

  public async gaisyutsu(syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null): Promise<Boolean> {
    const api = new DakokuApi()
    const req: DakokuReq = {
      syuugyouBasyoId,
      koyouKeiyakuId,
      koyouKeiyakuTimeId
    }

    let res = null;
    try {
      res = await api.gaisyutsu(req)
    } catch (e: any) {
      console.error(e);
      return false
    }

    return true
  }

  public async modori(syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null): Promise<Boolean> {
    const api = new DakokuApi()
    const req: DakokuReq = {
      syuugyouBasyoId,
      koyouKeiyakuId,
      koyouKeiyakuTimeId
    }

    let res = null;
    try {
      res = await api.modori(req)
    } catch (e: any) {
      console.error(e);
      return false
    }

    return res
  }

  public async taikin(syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null): Promise<Boolean> {
    const api = new DakokuApi()
    const req: DakokuReq = {
      syuugyouBasyoId,
      koyouKeiyakuId,
      koyouKeiyakuTimeId
    }

    let res = null;
    try {
      res = await api.taikin(req)
    } catch (e: any) {
      console.error(e);
      return false
    }

    return res
  }

  public async kyuukei(targetDate: Date, kyuukeiTimes: string, syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null): Promise<Boolean> {
    const api = new DakokuApi();
    const req: KyuukeiReq = {
      kyuukeiTimes,
      targetDate: DateUtil.format(targetDate, 'YYYY-MM-DD H:mm:ss'),
      koyouKeiyakuId,
      syuugyouBasyoId,
      koyouKeiyakuTimeId
    };

    let res = null;
    try {
      res = await api.kyuukei(req);
    } catch (e: any) {
      console.error(e);
      return false
    }

    return res
  }

  public async honninNotes(targetDate: Date | string, honninNotes: string, syuugyouBasyoId: number, koyouKeiyakuId: number | null, koyouKeiyakuTimeId: number | null): Promise<boolRes> {
    if (targetDate instanceof Date) {
      targetDate = targetDate.toDateString()
    }

    const api = new DakokuApi();
    const req: HonninNotesReq = {
      honninNotes,
      targetDate: DateUtil.format(targetDate, 'YYYY-MM-DD H:mm:ss'),
      koyouKeiyakuId,
      syuugyouBasyoId,
      koyouKeiyakuTimeId
    };

    let res = null;
    try {
      res = await api.honninNotes(req);
    } catch (e: any) {
      console.error(e);
      return e.response.data
    }

    return res
  }

  public async getKinmuList(year: number | null, month: number | null, syuugyouBasyoId: number, koyouKeiyakuId: number | null | undefined, targetUserId: number, dakokuId?: number | null): Promise<GetKinmuListRes | null> {
    const api = new DakokuApi()
    const req: GetKinmuListReq = {
      koyouKeiyakuId,
      syuugyouBasyoId,
      year,
      month,
      dakokuId,
      targetUserId,
    }

    let res = null;
    try {
      res = await api.getKinmuList(req)
      if (!res) {
        throw new Error('');
      }
    } catch (e: any) {
      return null
    }

    res.list = await this.convertKinmuList(cloneDeep(res.list))
    return res
  }

  private async convertKinmuList(kinmuList: KinmuListData[]) {
    const retKinmuList: KinmuListData[] = [];
    kinmuList.forEach(dakokuData => {
      const retKinmus: HakenDakokuData[] = []
      dakokuData.kinmus.forEach(kinmu => {
        if (!kinmu) {
          return
        }

        kinmu.dakoku_date = this.convertStrToDate(kinmu.dakoku_date)
        kinmu.syukkin_datetime = this.convertStrToDate(kinmu.syukkin_datetime)
        kinmu.syukkin_round_datetime = this.convertStrToDate(kinmu.syukkin_round_datetime)
        kinmu.gaisyutsu_datetime = this.convertStrToDate(kinmu.gaisyutsu_datetime)
        kinmu.gaisyutsu_round_datetime = this.convertStrToDate(kinmu.gaisyutsu_round_datetime)
        kinmu.modori_datetime = this.convertStrToDate(kinmu.modori_datetime)
        kinmu.modori_round_datetime = this.convertStrToDate(kinmu.modori_round_datetime)
        kinmu.taikin_datetime = this.convertStrToDate(kinmu.taikin_datetime)
        kinmu.taikin_round_datetime = this.convertStrToDate(kinmu.taikin_round_datetime)
        kinmu.taikin_round_datetime = this.convertStrToDate(kinmu.taikin_round_datetime)

        retKinmus.push(kinmu)
      })

      retKinmuList.push({
        key: dakokuData.key,
        datetime: new Date(dakokuData.datetime),
        date_for_display: dakokuData.date_for_display,
        kinmus: retKinmus,
        shinseis: dakokuData.shinseis,
        waitShinseis: dakokuData.waitShinseis,
        hayaban_osoban: dakokuData.hayaban_osoban,
        is_syounin_select: false
      })
    })

    return retKinmuList
  }

  public async getKintaiSummary(year: number, month: number, syuugyouBasyoId: number, koyouKeiyakuId: number | null = null, userId: number | null = null): Promise<KintaiSummaryData | null> {
    const api = new DakokuApi()

    const req: GetKintaiSummaryReq = {
      syuugyouBasyoId,
      koyouKeiyakuId,
      year,
      month,
      userId
    }

    let summary = null;
    try {
      const res = await api.getKintaiSummary(req)
      if (!res.summary) {
        throw new Error('');
      }
      summary = this.convertKintaiSummary(res.summary)
    } catch (e: any) {
      return null
    }

    return summary
  }

  public async getKintaiSummaryBySummaryId(summaryId: number){
    const api = new DakokuApi()

    try {
      const res = await api.getKintaiSummaryBySummaryId(summaryId)
      if (!res.summary) {
        throw new Error('');
      }
      return this.convertKintaiSummary(res.summary)
    } catch (e: any) {
      return null
    }

  }

  /**
   * GetDakokuResをDakokuDataへ変換
   * @param res
   * @returns
   */
  public async createDakokuData(dakokuData: DakokuData | null): Promise<DakokuData> {
    if (!dakokuData) {
      return {
        dakoku_id: null,
        user_id: null,
        dakoku_date: null,
        koyou_keiyaku_id: null,
        syukkin_datetime: null,
        taikin_datetime: null,
        gaisyutsu_datetime: null,
        modori_datetime: null,
        kyuukei_times: null,
        gaisyutsu_times: null,
        reported_kyuukei_times: null,
        honnin_notes: null,
        syounin_status_type: null,
        koyou_keiyaku_time_id: null,
        is_koukyuu: false,
      };
    }

    if (isString(dakokuData.dakoku_date)) {
      dakokuData.dakoku_date = new Date(DateUtil.formatFullDateTime(dakokuData.dakoku_date))
    }

    if (isString(dakokuData.syukkin_datetime)) {
      dakokuData.syukkin_datetime = new Date(DateUtil.formatFullDateTime(dakokuData.syukkin_datetime))
    }

    if (isString(dakokuData.gaisyutsu_datetime)) {
      dakokuData.gaisyutsu_datetime = new Date(DateUtil.formatFullDateTime(dakokuData.gaisyutsu_datetime))
    }

    if (isString(dakokuData.modori_datetime)) {
      dakokuData.modori_datetime = new Date(DateUtil.formatFullDateTime(dakokuData.modori_datetime))
    }

    if (isString(dakokuData.taikin_datetime)) {
      dakokuData.taikin_datetime = new Date(DateUtil.formatFullDateTime(dakokuData.taikin_datetime))
    }

    return dakokuData
  }

  private convertStrToDate(date: string | Date | null) {
    if (isString(date)) {
      return new Date(DateUtil.formatFullDateTime(date))
    }
    return date
  }

  /**
   * DakokuDataFullResをDakokuDataFullへ変換
   * @param dakokuData
   * @returns
   */
  public convertKintaiSummary(summary: KintaiSummaryData): KintaiSummaryData {
    if (isString(summary.start_date)) {
      summary.start_date = new Date(DateUtil.format(summary.start_date))
    }

    if (isString(summary.end_date)) {
      summary.end_date = new Date(DateUtil.format(summary.end_date))
    }

    return summary
  }

  public async dakokuSyounin(dakokuId: number, syouninStatusType: number, syouninStatusNotes: string): Promise<boolRes> {
    const api = new DakokuApi();
    const req: DakokuSyouninReq = {
      dakokuId,
      syouninStatusType,
      syouninStatusNotes
    };

    let res = null;
    try {
      res = await api.dakokuSyounin(req);
      if (!res) {
        throw new Error('')
      }
    } catch (e: any) {
      console.error(e);
      return e.response.data
    }

    return res
  }

  public async getHakenKinmuList(
    year: number | null, month: number | null, syuugyouBasyoId: number, koyouKeiyakuId: number | null | undefined, targetUserId: number, dakokuId?: number | null
  ) {
    const req: GetKinmuListReq = {
      koyouKeiyakuId,
      syuugyouBasyoId,
      year,
      month,
      dakokuId,
      targetUserId
    }

    const api = new DakokuApi()
    let res = null;
    try {
      res = await api.getHakenKinmuList(req)
      if (!res) {
        throw new Error('');
      }
    } catch (e: any) {
      return null
    }

    res.list = await this.convertHakenKinmuList(cloneDeep(res.list))
    return res
  };

  public async getHakenKinmuListBySummaryId(summaryId: number) {
    const req: GetKinmuListBySummaryIdReq = {
      summaryId
    }

    const api = new DakokuApi()
    let res = null;
    try {
      res = await api.getHakenKinmuListBySummaryId(req)
      if (!res) {
        throw new Error('');
      }
    } catch (e: any) {
      return null
    }

    res.list = await this.convertHakenKinmuList(cloneDeep(res.list))
    return res
  }

  private async convertHakenKinmuList(kinmuList: HakenKinmuListData[]) {
    const retHakenKinmuList: HakenKinmuListData[] = [];
    kinmuList.forEach(dakokuData => {
      const retKinmus: HakenDakokuData[] = [];
      dakokuData.kinmus.forEach(kinmu => {
        if (!kinmu) {
          return;
        }

        kinmu.dakoku_date = this.convertStrToDate(kinmu.dakoku_date)
        kinmu.syukkin_datetime = this.convertStrToDate(kinmu.syukkin_datetime)
        kinmu.syukkin_round_datetime = this.convertStrToDate(kinmu.syukkin_round_datetime)
        kinmu.gaisyutsu_datetime = this.convertStrToDate(kinmu.gaisyutsu_datetime)
        kinmu.gaisyutsu_round_datetime = this.convertStrToDate(kinmu.gaisyutsu_round_datetime)
        kinmu.modori_datetime = this.convertStrToDate(kinmu.modori_datetime)
        kinmu.modori_round_datetime = this.convertStrToDate(kinmu.modori_round_datetime)
        kinmu.taikin_datetime = this.convertStrToDate(kinmu.taikin_datetime)
        kinmu.taikin_round_datetime = this.convertStrToDate(kinmu.taikin_round_datetime)
        kinmu.taikin_round_datetime = this.convertStrToDate(kinmu.taikin_round_datetime)

        retKinmus.push(kinmu)
      })

      retHakenKinmuList.push({
        key: dakokuData.key,
        datetime: new Date(dakokuData.datetime),
        date_for_display: dakokuData.date_for_display,
        kinmus: retKinmus,
        shinseis: dakokuData.shinseis,
        waitShinseis: dakokuData.waitShinseis,
        hayaban_osoban: dakokuData.hayaban_osoban
      })
    })

    return retHakenKinmuList
  }

  public async closeKintaiSummary(kintaiSummaryId: number, comment: string | null, dakokuSyouninGroupId: number | null, syouninUserName: string | null,  syouninUserYakusyoku: string | null): Promise<boolean> {
    const api = new DakokuApi();
    const req: CloseKintaiSummaryReq = {
      kintaiSummaryId,
      comment,
      dakokuSyouninGroupId,
      syouninUserName,
      syouninUserYakusyoku
    };

    let res = null;
    try {
      res = await api.closeKintaiSummary(req);
    } catch (e: any) {
      console.error(e);
      return false
    }
    return res
  }

  public async closeCancelKintaiSummary(kintaiSummaryId: number): Promise<boolean> {
    const api = new DakokuApi();
    const req: CloseCancelKintaiSummaryReq = {
      kintaiSummaryId
    };

    let res = null;
    try {
      res = await api.closeCancelKintaiSummary(req);
    } catch (e: any) {
      console.error(e);
      return false
    }

    return res
  }

  public async modifyKintaiSummary(summary: KintaiSummaryData): Promise<boolean> {
    const api = new DakokuApi();

    try {
      return await api.modifyKintaiSummary(summary);
    } catch (e: any) {
      console.error(e);
      return false
    }
  }

  public async getKinmuListInfoByDakokuId(dakokuId: number | null) {
    if (isNull(dakokuId)) {
      return null
    }

    const api = new DakokuApi();
    return await api.getKinmuListInfoByDakokuId(dakokuId)
  }

  public async ikkatsuSyounin(params: number[]): Promise<boolean> {
    const api = new DakokuApi();
    try {
      return await api.ikkatsuSyounin(params);
    } catch (e) {
      return false;
    }
  }

  public async setHakenModifies(params: HakenModifyDatas) {
    const api = new DakokuApi();

    try {
      return await api.setHakenModifies(params);
    } catch (e: any) {
      console.error(e);
      return false
    }
  }

  /**
   * 総務修正を登録します。
   * @param params
   * @returns 登録件数
   */
  public async updateSoumuSyuusei(req: SoumuSyuuseiReq): Promise<boolean> {
    const api = new DakokuApi();
    try {
      return await api.updateSoumuSyuusei(req);
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 打刻の再計算を行います
   */
  public async recalcDakokuByDakokuInfos(dakokuInfos: RecalcDakokByDakokuInfo[], force: boolean = false): Promise<boolean> {
    const api = new DakokuApi();
    const req :RecalcDakokByDakokuInfouReq = {
      dakokuInfos,
      force,
    }
    try {
      return await api.recalcDakokuByDakokuInfos(req);
    } catch (e: any) {
      throw e;
    }
  }
}
